module.exports = __webpack_public_path__ + "img/ActivityLog.9e25f81c.svg";